// extracted by mini-css-extract-plugin
export default {"root":"root___rkT9F","benefit_block":"benefit_block___AACCD","desc":"desc___pb_Iq","map":"map___b7rou","shield":"shield___ilx3z","speedy":"speedy___kuFBO"};